import React from 'react';
import PropTypes from 'prop-types';
import InstagramMediaItem from './InstagramMediaItem';

const InstagramMediaCarousel = ({ mediaItems, activeIndex }) => (
  <InstagramMediaItem media={mediaItems[activeIndex]} />
);

InstagramMediaCarousel.propTypes = {
  mediaItems: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
};

export default InstagramMediaCarousel;
